import {fetchProvider} from '../../utils/fetchProvider';

export const getCardDetails = ({languageCode: lang, paymentSessionId: id}) => {
    const url = `/${lang}/payments-integrations-webapp/props/getTabapayCardDetails?paymentSessionId=${id}`;

    return fetchProvider(url);
};

export const initTransaction = ({csrfToken, securityCode}) => {
    const url = `${window.location.href}/init`;

    return fetchProvider(url, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'csrf-token': csrfToken
        },
        body: JSON.stringify({
            securityCode
        })
    }).catch(err => {
        throw new Error(`Tabapay init transaction: ${err.message}`);
    });
};


export const getTabapayStatus = async ({languageCode, paymentSessionId}) => {
    const url = new URL(
        `/${languageCode}/payments-integrations-webapp/props/getTabapayStatus`,
        window.location.origin
    );
    url.searchParams.set('paymentSessionId', paymentSessionId);

    return fetchProvider(url, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    }).catch(err => {
        throw new Error(`Tabapay transaction status: ${err.message}`);
    });
};


export default {
    getCardDetails,
    initTransaction,
    getTabapayStatus
};
